export enum MessageType {
  text = 1,
  helpCard = 2,
  helpRoom = 3,
}
